import { render } from "./OnboardingTemplatePreview.vue?vue&type=template&id=c749d40e&scoped=true"
import script from "./OnboardingTemplatePreview.vue?vue&type=script&lang=js"
export * from "./OnboardingTemplatePreview.vue?vue&type=script&lang=js"

import "./OnboardingTemplatePreview.vue?vue&type=style&index=0&id=c749d40e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c749d40e"],['__file',"src/scripts/portfolioManager/onboarding/OnboardingTemplatePreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c749d40e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c749d40e', __exports__)) {
    api.reload('c749d40e', __exports__)
  }
  
  module.hot.accept("./OnboardingTemplatePreview.vue?vue&type=template&id=c749d40e&scoped=true", () => {
    api.rerender('c749d40e', render)
  })

}


export default __exports__